import { render, staticRenderFns } from "./Movimientos.vue?vue&type=template&id=03b565be"
import script from "./Movimientos.vue?vue&type=script&lang=js"
export * from "./Movimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports